import { UsersIcon, Building2Icon, DownloadIcon, ClockIcon, GraduationCapIcon, LayersIcon, SmartphoneIcon, type LucideIcon } from 'lucide-react';

export interface TrustStat {
  icon: LucideIcon;
  value: string;
  label: string;
}

export const trustStats: TrustStat[] = [
  { icon: UsersIcon, value: '+9K', label: 'Entrenadores activos' },
  { icon: Building2Icon, value: 'Más de 1.000', label: 'Clubes y Colegios' },
  { icon: DownloadIcon, value: '+150.000', label: 'Sesiones descargadas' },
  { icon: ClockIcon, value: '+4 horas', label: 'Ahorradas / semana' }
];

export interface TrustBadge {
  icon: LucideIcon;
  title: string;
  text: string;
}

export const trustBadges: TrustBadge[] = [
  {
    icon: GraduationCapIcon,
    title: 'Fútbol Formativo Real',
    text: 'Diseñado por entrenadores con años de experiencia en el fútbol formativo. Para la realidad del día a día en el campo, tus jugadores y las familias presentes.'
  },
  {
    icon: LayersIcon,
    title: 'Todas las Categorías',
    text: 'Desde Benjamín (6-8 años) hasta Regional/Amateur. Con adaptaciones específicas para Fútbol 7 y Fútbol 11.'
  },
  {
    icon: SmartphoneIcon,
    title: 'Multidispositivo',
    text: 'Tablet, móvil, PC o para imprimir — consúltalo desde la zona técnica sin que nadie lo note.'
  }
];
